<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('segmento-fundamental-i')" class="main mb-5" id="about-main">
      <b-container>
        <b-card no-body class="shadow-sm card_sistemacpv p-4">
          <b-row>
            <b-col cols="12" md="6" lg="4" xl="3" v-for="(list, index) in lists" :key="index">
              <router-link :to="`${list.link_name}`">
                <b-card no-body :style="list.colorCard" :class="list.bg__link" class="card-link shadow-sm border-0">
                  <p class="text-center text-white"><i :class="list.iconClass"></i></p>
                  <h6 class="text-uppercase font-weight-bold text-center text-white">{{ list.title }}</h6>
                  <p class="text-center text-white">{{ list.text }}</p>
                  <div class="corner d-none d-md-none d-lg-flex">
                    <div class="arrow">
                      <i class="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

  <script>  
require('baguettebox.js/dist/baguetteBox.min.css');

export default {
  name: 'ensino-fundamental-1-caderno-digital',
  metaInfo: {
    title: 'COLEÇÃO CPV',
  },
  props: {},

  data() {
    return {
      NamePermission: '',
      IndexPermission: '',
      pageTitle: 'ENSINO FUNDAMENTAL I',
      pageSubtitle: 'CONHEÇA A COLEÇÃO CPV',

      Deselect: {
        render: (createElement) => createElement('span', ''),
      },

      title2: '',
      nome_arquivo: '',

      selected: null,

      filterOption: 'Todos',
      MySearch: '',
      SearchTitle: '',
      SearchDiscipline: '',
      SearchSegment: '',
      SearchBundle: '',

      lists: [
        {
          title: '1º Ano',
          text: '',
          link_name: 'fundamental-1-primeiro-ano',
          iconClass: 'fa-light fa-square-1 fa-3x',
          colorCard: {
            'background-color': '#38aaf3',
            'border:': '1px solid #38aaf3',
            'border-radius': '0.5rem',
            color: '#ffffff',
          },
          permission: 'segmento-fundamental-i',
          bg__link: 'infantil',
          // childSlug: 'infantil-2-maternal-i'
        },
        {
          title: '2º Ano',
          text: '',
          link_name: 'fundamental-1-segundo-ano',
          iconClass: 'fa-light fa-square-2 fa-3x',
          colorCard: {
            'background-color': '#4ac8aa',
            'border:': '1px solid #4ac8aa',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-fundamental-i',
          bg__link: 'fundamental-i',
          // childSlug: 'infantil-3-maternal-ii'
        },
        {
          title: '3º Ano',
          text: '',
          link_name: 'fundamental-1-terceiro-ano',
          iconClass: 'fa-light fa-square-3 fa-3x',
          colorCard: {
            'background-color': '#a7dc48',
            'border:': '1px solid #a7dc48',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-fundamental-i',
          bg__link: 'fundamental-ii',
          // childSlug: 'infantil-4-jardim-i'
        },
        {
          title: '4º Ano',
          text: '',
          link_name: 'fundamental-1-quarto-ano',
          iconClass: 'fa-light fa-square-4 fa-3x',
          colorCard: {
            'background-color': '#fc5b5b',
            'border:': '1px solid #fc5b5b',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-fundamental-i',
          bg__link: 'medio',
          // childSlug: 'infantil-5-jardim-ii'
        },
        {
          title: '5º Ano',
          text: '',
          link_name: 'fundamental-1-quinto-ano',
          iconClass: 'fa-light fa-square-5 fa-3x',
          colorCard: {
            'background-color': '#fa6d9e',
            'border:': '1px solid #fa6d9e',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-fundamental-i',
          bg__link: 'pre-vestibular',
          // childSlug: 'flashcards'
        },
        {
          title: 'Materiais Complementares',
          text: '',
          link_name: 'fundamental-1-material-complementar',
          iconClass: 'fa-light fa-book fa-3x',
          colorCard: {
            'background-color': '#F8B03D',
            'border:': '1px solid #F8B03D',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-fundamental-i',
          bg__link: 'enem',
          // childSlug: 'flashcards'
        },
      ],
    };
  },
  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },
  computed: {
    filterHead() {
      return this.list.filter((ret) => {
        return (
          ret.title.match(this.SearchTitle) &&
          ret.bundle.match(this.SearchBundle.value) &&
          ret.discipline.match(this.SearchDiscipline) &&
          ret.segment.match(this.SearchSegment.value)
        );
      });
    },
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    onComplete: function () {
      this.$router.push({
        name: 'pdf-read-only',
        params: {
          nome_arquivo: this.nome_arquivo,
          title2: this.title2,
        },
      });
    },

    reload() {
      location.reload();
    },

    resetOptions: function () {
      (this.SearchBundle = ''),
        (this.SearchTitle = ''),
        (this.SearchDiscipline = ''),
        (this.SearchSegment.name = ''),
        this.reload();
    },
  },
};
</script>

 <style scoped> 
.main {
  margin-top: 30px;
}

.card_sistemacpv {
    border-radius: 8px;
    color: #3A1C53;
}
</style>
